export const CIRCLE_SIZE_PX = '24px';
export const CIRCLE_BORDER_PX = '4px';
export const LINE_WIDTH_PX = '2px';

export const TIMELINE_SECTIONS_GAP_PX = '32px';
export const TIMELINE_SUBSECTIONS_GAP_PX = '8px';
